import './index.css'

function StatusPill({ colour, text, active }) {
    return (
        <div
            className={`status-pill ${active ? 'status-pill--active' : ''}`}
            style={active ? { '--pill-colour': colour } : undefined}
        >
            <span className='status-pill-dot' />
            {text}
        </div>
    );
}

export default StatusPill
